// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type MutationOptions,
  queryOptions,
} from '@tanstack/solid-query';

import { client } from '../client.gen';
import {
  batchGet,
  batchGetDefinitions,
  batchGetPSets,
  batchGetPSetsByDef,
  changesetPSets,
  changesetPSetsAsync,
  createDefinition,
  createLibrary,
  deleteDefinition,
  deleteLibrary,
  deletePSet,
  getChangesetStatus,
  getDefinition,
  getDefinitionVersion,
  getDefinitionVersionBySchema,
  getLibrary,
  getLibraryPolicy,
  getPSet,
  getPSetVersion,
  landingPage,
  listDefinitions,
  listDefinitionVersions,
  listPSetChangesByDef,
  listPSetChangesByLib,
  listPSetsByDef,
  listPSetsByLib,
  listPsetsByLink,
  listPSetsOld,
  listPSetVersions,
  me,
  type Options,
  psetsSync,
  subscribe,
  updateLibraryPolicy,
  updatePSet,
  upsertDefinition,
  upsertLibrary,
  validatePsets,
  xdomain,
} from '../sdk.gen';
import type {
  BatchGetData,
  BatchGetDefinitionsData,
  BatchGetDefinitionsError2,
  BatchGetDefinitionsResponse2,
  BatchGetError,
  BatchGetPSetsByDefData,
  BatchGetPSetsByDefError,
  BatchGetPSetsByDefResponse2,
  BatchGetPSetsData,
  BatchGetPSetsError,
  BatchGetPSetsResponse2,
  BatchGetResponse2,
  ChangesetPSetsAsyncData,
  ChangesetPSetsAsyncError,
  ChangesetPSetsAsyncResponse,
  ChangesetPSetsData,
  ChangesetPSetsError,
  ChangesetPSetsResponse,
  CreateDefinitionData,
  CreateDefinitionError,
  CreateDefinitionResponse,
  CreateLibraryData,
  CreateLibraryError,
  CreateLibraryResponse,
  DeleteDefinitionData,
  DeleteDefinitionError,
  DeleteDefinitionResponse,
  DeleteLibraryData,
  DeleteLibraryError,
  DeleteLibraryResponse,
  DeletePSetData,
  DeletePSetError,
  DeletePSetResponse,
  GetChangesetStatusData,
  GetChangesetStatusError,
  GetChangesetStatusResponse,
  GetDefinitionData,
  GetDefinitionError,
  GetDefinitionResponse,
  GetDefinitionVersionBySchemaData,
  GetDefinitionVersionBySchemaError,
  GetDefinitionVersionBySchemaResponse,
  GetDefinitionVersionData,
  GetDefinitionVersionError,
  GetDefinitionVersionResponse,
  GetLibraryData,
  GetLibraryError,
  GetLibraryPolicyData,
  GetLibraryPolicyError,
  GetLibraryPolicyResponse,
  GetLibraryResponse,
  GetPSetData,
  GetPSetError,
  GetPSetResponse,
  GetPSetVersionData,
  GetPSetVersionError,
  GetPSetVersionResponse,
  LandingPageData,
  ListDefinitionsData,
  ListDefinitionsError,
  ListDefinitionsResponse,
  ListDefinitionVersionsData,
  ListDefinitionVersionsError,
  ListDefinitionVersionsResponse,
  ListPSetChangesByDefData,
  ListPSetChangesByDefError,
  ListPSetChangesByDefResponse,
  ListPSetChangesByLibData,
  ListPSetChangesByLibError,
  ListPSetChangesByLibResponse,
  ListPSetsByDefData,
  ListPSetsByDefError,
  ListPSetsByDefResponse,
  ListPSetsByLibData,
  ListPSetsByLibError,
  ListPSetsByLibResponse,
  ListPsetsByLinkData,
  ListPsetsByLinkError,
  ListPsetsByLinkResponse,
  ListPSetsOldData,
  ListPSetsOldError,
  ListPSetsOldResponse,
  ListPSetVersionsData,
  ListPSetVersionsError,
  ListPSetVersionsResponse,
  MeData,
  MeError,
  MeResponse,
  PsetsSyncData,
  PsetsSyncError,
  PsetsSyncResponse,
  SubscribeData,
  SubscribeError,
  SubscribeResponse,
  UpdateLibraryPolicyData,
  UpdateLibraryPolicyError,
  UpdateLibraryPolicyResponse,
  UpdatePSetData,
  UpdatePSetError,
  UpdatePSetResponse,
  UpsertDefinitionData,
  UpsertDefinitionError,
  UpsertDefinitionResponse,
  UpsertLibraryData,
  UpsertLibraryError,
  UpsertLibraryResponse2,
  ValidatePsetsData,
  ValidatePsetsError,
  ValidatePsetsResponse,
  XdomainData,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const landingPageQueryKey = (options?: Options<LandingPageData>) =>
  createQueryKey('landingPage', options);

/**
 * Landing page
 *
 * The Service landing web page containing API usage information and useful links.
 */
export const landingPageOptions = (options?: Options<LandingPageData>) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof landingPageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await landingPage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: landingPageQueryKey(options),
  });

export const xdomainQueryKey = (options?: Options<XdomainData>) =>
  createQueryKey('xdomain', options);

/**
 * (Experimental) CORS xdomain proxy
 *
 * The experimental xdomain proxy to avoid the pre-flight requests (CORS) in web apps that are using this public API. A static resource that can be used to proxy all API calls to this service to avoid pre-flight requests. On your web page add the following script. It's important to include XDomain before any other library. When XDomain loads, XHook replaces the current window.XMLHttpRequest. So if another library saves a reference to the original window.XMLHttpRequest and uses that, XHook won't be able to intercept those requests.
 * ```javascript <script src="https://unpkg.com/xdomain@0.8.2/dist/xdomain.min.js" slave="https://pset-api.connect.trimble.com/v1/proxy.html"></script> ```
 * After that, any XHR to https://pset-api.connect.trimble.com origin mentioned in the `slave` property will automagically work without a pre-flight request
 */
export const xdomainOptions = (options?: Options<XdomainData>) =>
  queryOptions<
    unknown,
    DefaultError,
    unknown,
    ReturnType<typeof xdomainQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await xdomain({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: xdomainQueryKey(options),
  });

export const subscribeQueryKey = (options?: Options<SubscribeData>) =>
  createQueryKey('subscribe', options);

/**
 * Subscribe
 *
 * Get information about subscribing to notification websocket.
 */
export const subscribeOptions = (options?: Options<SubscribeData>) =>
  queryOptions<
    SubscribeResponse,
    SubscribeError,
    SubscribeResponse,
    ReturnType<typeof subscribeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await subscribe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: subscribeQueryKey(options),
  });

export const meQueryKey = (options?: Options<MeData>) =>
  createQueryKey('me', options);

/**
 * Me
 *
 * Get information about the user bearer token belongs to.
 */
export const meOptions = (options?: Options<MeData>) =>
  queryOptions<MeResponse, MeError, MeResponse, ReturnType<typeof meQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await me({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: meQueryKey(options),
  });

export const getLibraryPolicyQueryKey = (
  options: Options<GetLibraryPolicyData>
) => createQueryKey('getLibraryPolicy', options);

/**
 * GetLibraryPolicy.
 *
 * Get the access control policy attached to the library.
 */
export const getLibraryPolicyOptions = (
  options: Options<GetLibraryPolicyData>
) =>
  queryOptions<
    GetLibraryPolicyResponse,
    GetLibraryPolicyError,
    GetLibraryPolicyResponse,
    ReturnType<typeof getLibraryPolicyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLibraryPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLibraryPolicyQueryKey(options),
  });

/**
 * UpdateLibraryPolicy.
 *
 * This operation allows to update an access control policy attached to the library.
 */
export const updateLibraryPolicyMutation = (
  options?: Partial<Options<UpdateLibraryPolicyData>>
): MutationOptions<
  UpdateLibraryPolicyResponse,
  UpdateLibraryPolicyError,
  Options<UpdateLibraryPolicyData>
> => {
  const mutationOptions: MutationOptions<
    UpdateLibraryPolicyResponse,
    UpdateLibraryPolicyError,
    Options<UpdateLibraryPolicyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLibraryPolicy({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * CreateLibrary
 *
 * Create a new library. This operation supports a deep insert semantic and allows to create definitions under the new library as part of the same operation.
 */
export const createLibraryMutation = (
  options?: Partial<Options<CreateLibraryData>>
): MutationOptions<
  CreateLibraryResponse,
  CreateLibraryError,
  Options<CreateLibraryData>
> => {
  const mutationOptions: MutationOptions<
    CreateLibraryResponse,
    CreateLibraryError,
    Options<CreateLibraryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createLibrary({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * DeleteLibrary
 *
 * Mark library with given id as deleted. A resource is not deleted from the system but marked as deleted. All data is preserved. The version of the resource is incremented. Most of the other operations will refuse to work with items marked as deleted unless the 'deleted' query parameter is specified. A resource can be undeleted with PATCH operation.
 */
export const deleteLibraryMutation = (
  options?: Partial<Options<DeleteLibraryData>>
): MutationOptions<
  DeleteLibraryResponse,
  DeleteLibraryError,
  Options<DeleteLibraryData>
> => {
  const mutationOptions: MutationOptions<
    DeleteLibraryResponse,
    DeleteLibraryError,
    Options<DeleteLibraryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteLibrary({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLibraryQueryKey = (options: Options<GetLibraryData>) =>
  createQueryKey('getLibrary', options);

/**
 * GetLibrary
 *
 * Get information about library with given id.
 */
export const getLibraryOptions = (options: Options<GetLibraryData>) =>
  queryOptions<
    GetLibraryResponse,
    GetLibraryError,
    GetLibraryResponse,
    ReturnType<typeof getLibraryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLibrary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLibraryQueryKey(options),
  });

/**
 * UpsertLibrary
 *
 * Update or create a library resource with given id. This operation will undelete the library resource if it exists and was marked as deleted. The existing resource version is incremented. To ensure that this request is not treated as an insert and be executed as an update, the client MAY specifies an `If-Match` header. To ensure that this request is not treated as an update and be executed as insert, the client MAY specify an `If-None-Match` header with a value of `*`.
 */
export const upsertLibraryMutation = (
  options?: Partial<Options<UpsertLibraryData>>
): MutationOptions<
  UpsertLibraryResponse2,
  UpsertLibraryError,
  Options<UpsertLibraryData>
> => {
  const mutationOptions: MutationOptions<
    UpsertLibraryResponse2,
    UpsertLibraryError,
    Options<UpsertLibraryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertLibrary({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listDefinitionsQueryKey = (
  options: Options<ListDefinitionsData>
) => createQueryKey('listDefinitions', options);

/**
 * ListDefinitions
 *
 * The pset definitions user has access to are returned in pages. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, you will need to paginate the result set. Note. A `ListDefinitions` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out.
 */
export const listDefinitionsOptions = (options: Options<ListDefinitionsData>) =>
  queryOptions<
    ListDefinitionsResponse,
    ListDefinitionsError,
    ListDefinitionsResponse,
    ReturnType<typeof listDefinitionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDefinitions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listDefinitionsQueryKey(options),
  });

/**
 * CreateDefinition
 *
 * Create a new pset definition.
 */
export const createDefinitionMutation = (
  options?: Partial<Options<CreateDefinitionData>>
): MutationOptions<
  CreateDefinitionResponse,
  CreateDefinitionError,
  Options<CreateDefinitionData>
> => {
  const mutationOptions: MutationOptions<
    CreateDefinitionResponse,
    CreateDefinitionError,
    Options<CreateDefinitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createDefinition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * DeleteDefinition
 *
 * Mark pset definition with given id as deleted. A resource is not deleted from the system but marked as deleted. All data is preserved. The version of the resource is incremented. Most of the other operations will refuse to work with items marked as deleted unless the 'deleted' query parameter is specified. A resource can be undeleted with PATCH operation.
 */
export const deleteDefinitionMutation = (
  options?: Partial<Options<DeleteDefinitionData>>
): MutationOptions<
  DeleteDefinitionResponse,
  DeleteDefinitionError,
  Options<DeleteDefinitionData>
> => {
  const mutationOptions: MutationOptions<
    DeleteDefinitionResponse,
    DeleteDefinitionError,
    Options<DeleteDefinitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteDefinition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDefinitionQueryKey = (options: Options<GetDefinitionData>) =>
  createQueryKey('getDefinition', options);

/**
 * GetDefinition
 *
 * Get information about pset definition with given id.
 */
export const getDefinitionOptions = (options: Options<GetDefinitionData>) =>
  queryOptions<
    GetDefinitionResponse,
    GetDefinitionError,
    GetDefinitionResponse,
    ReturnType<typeof getDefinitionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDefinition({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDefinitionQueryKey(options),
  });

/**
 * UpsertDefinition
 *
 * Update pset definition resource with given id. This operation will undelete the pset definition resource if it exists and was marked as deleted. The existing resource version is incremented. The schema resource is incremented if and only if the schema property is present in the request body. To ensure that this request is not treated as an insert and be executed as an update, the client MAY specifies an `If-Match` header. To ensure that this request is not treated as an update and be executed as insert, the client MAY specify an `If-None-Match` header with the value of `*`.
 */
export const upsertDefinitionMutation = (
  options?: Partial<Options<UpsertDefinitionData>>
): MutationOptions<
  UpsertDefinitionResponse,
  UpsertDefinitionError,
  Options<UpsertDefinitionData>
> => {
  const mutationOptions: MutationOptions<
    UpsertDefinitionResponse,
    UpsertDefinitionError,
    Options<UpsertDefinitionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await upsertDefinition({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listPSetsByLibQueryKey = (options: Options<ListPSetsByLibData>) =>
  createQueryKey('listPSetsByLib', options);

/**
 * Lists PSets by a pset library.
 *
 * Lists the non-deleted psets by a pset library the current user has access to. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, it indicates more psets might be available and can be fetched using the link in the `next` property. To fetch full set of psets keep fetching the `next` pages until the response returned does not contain the `next` property. Note, a `ListPSetsByLib` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out.
 *
 * The `changeToken` returned with each page can be used to call the [ListChanges](#/PSets/ListPSetChangesByLib) API and fetch all the changes that has happened after the last pset returned on this page. Typically the `changeToken` returned on the last page is used to monitor for changes.
 */
export const listPSetsByLibOptions = (options: Options<ListPSetsByLibData>) =>
  queryOptions<
    ListPSetsByLibResponse,
    ListPSetsByLibError,
    ListPSetsByLibResponse,
    ReturnType<typeof listPSetsByLibQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPSetsByLib({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPSetsByLibQueryKey(options),
  });

export const listPSetsByDefQueryKey = (options: Options<ListPSetsByDefData>) =>
  createQueryKey('listPSetsByDef', options);

/**
 * Lists PSets by a pset definition.
 *
 * The psets current user has access to by query (e.g. by a pset definition) in pages. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, you will need to paginate the result set. Note, a `ListPSetsByDef` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out. Client have to iterate until `next` property in the response is not present.
 *
 * For initial synchronization in definition scope query parameter `sortBy=modifiedAt` must be used. In that case page of responses also contains cursor (known as `changeToken`) of the latest information returned so that later [ListPSetChangesByDef](#/PSets/ListPSetChangesByDef) can return changed psets only.
 */
export const listPSetsByDefOptions = (options: Options<ListPSetsByDefData>) =>
  queryOptions<
    ListPSetsByDefResponse,
    ListPSetsByDefError,
    ListPSetsByDefResponse,
    ReturnType<typeof listPSetsByDefQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPSetsByDef({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPSetsByDefQueryKey(options),
  });

/**
 * BatchGetDefinitions
 *
 * Batch get pset definitions by listing definition identities in request. A single operation can retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGetDefinitions` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 * This API is a variation of a more generic /batch-get API. The libId given in the YRL acts as a default value for the definition of identity if this property is not specified explicitly in the request body.
 *
 * @deprecated
 */
export const batchGetDefinitionsMutation = (
  options?: Partial<Options<BatchGetDefinitionsData>>
): MutationOptions<
  BatchGetDefinitionsResponse2,
  BatchGetDefinitionsError2,
  Options<BatchGetDefinitionsData>
> => {
  const mutationOptions: MutationOptions<
    BatchGetDefinitionsResponse2,
    BatchGetDefinitionsError2,
    Options<BatchGetDefinitionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await batchGetDefinitions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listDefinitionVersionsQueryKey = (
  options: Options<ListDefinitionVersionsData>
) => createQueryKey('listDefinitionVersions', options);

/**
 * ListDefinitionVersions
 *
 * Returns the collection of versions for the given pset definition.
 */
export const listDefinitionVersionsOptions = (
  options: Options<ListDefinitionVersionsData>
) =>
  queryOptions<
    ListDefinitionVersionsResponse,
    ListDefinitionVersionsError,
    ListDefinitionVersionsResponse,
    ReturnType<typeof listDefinitionVersionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listDefinitionVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listDefinitionVersionsQueryKey(options),
  });

/**
 * ValidatePsets
 *
 * Validates existing psets against the proposed definition schema and returns number of valid and invalid instances. Depending on the amount of existing data this API might take a long time to execute, so partial result might be returned with a link to the next page that allows resuming the validation for the next portion of the existing data. Requires `pset:ValidatePSets` permission.
 */
export const validatePsetsMutation = (
  options?: Partial<Options<ValidatePsetsData>>
): MutationOptions<
  ValidatePsetsResponse,
  ValidatePsetsError,
  Options<ValidatePsetsData>
> => {
  const mutationOptions: MutationOptions<
    ValidatePsetsResponse,
    ValidatePsetsError,
    Options<ValidatePsetsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await validatePsets({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDefinitionVersionQueryKey = (
  options: Options<GetDefinitionVersionData>
) => createQueryKey('getDefinitionVersion', options);

/**
 * GetDefinitionVersion
 *
 * Returns specific version for the given pset definition. Requested version if exists always returned even if resource is marked as deleted.
 */
export const getDefinitionVersionOptions = (
  options: Options<GetDefinitionVersionData>
) =>
  queryOptions<
    GetDefinitionVersionResponse,
    GetDefinitionVersionError,
    GetDefinitionVersionResponse,
    ReturnType<typeof getDefinitionVersionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDefinitionVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDefinitionVersionQueryKey(options),
  });

export const getDefinitionVersionBySchemaQueryKey = (
  options: Options<GetDefinitionVersionBySchemaData>
) => createQueryKey('getDefinitionVersionBySchema', options);

/**
 * GetDefinitionVersionBySchema
 *
 * Returns the pset definition version for that has a given schema version. If several pset definition versions refer to the same schema version the latest resource version is returned.
 */
export const getDefinitionVersionBySchemaOptions = (
  options: Options<GetDefinitionVersionBySchemaData>
) =>
  queryOptions<
    GetDefinitionVersionBySchemaResponse,
    GetDefinitionVersionBySchemaError,
    GetDefinitionVersionBySchemaResponse,
    ReturnType<typeof getDefinitionVersionBySchemaQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDefinitionVersionBySchema({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDefinitionVersionBySchemaQueryKey(options),
  });

/**
 * BatchGet
 *
 * Batch get resources (libs, defs, psets) by list of identities. A single operation can retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGet` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 */
export const batchGetMutation = (
  options?: Partial<Options<BatchGetData>>
): MutationOptions<BatchGetResponse2, BatchGetError, Options<BatchGetData>> => {
  const mutationOptions: MutationOptions<
    BatchGetResponse2,
    BatchGetError,
    Options<BatchGetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await batchGet({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listPSetsOldQueryKey = (options: Options<ListPSetsOldData>) =>
  createQueryKey('listPSetsOld', options);

/**
 * ListPSets
 *
 * The psets current user has access to by for a given pset definition in pages. A single operation will read up to the maximum number of items set (if using the top parameter) or a maximum of 500 KB of data and then apply any filtering to the results. If `next` is present in the response, you will need to paginate the result set. Note, a `ListPSets` operation can return an empty result set and a `next` if all the items read for the page of results are filtered out. Client have to iterate until `next` property in the response is not present.
 *
 * @deprecated
 */
export const listPSetsOldOptions = (options: Options<ListPSetsOldData>) =>
  queryOptions<
    ListPSetsOldResponse,
    ListPSetsOldError,
    ListPSetsOldResponse,
    ReturnType<typeof listPSetsOldQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPSetsOld({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPSetsOldQueryKey(options),
  });

/**
 * BatchGetPSets
 *
 * Batch get pset instances by listing pset identities in the request. A single operation cat retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGetPSets` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 *
 * @deprecated
 */
export const batchGetPSetsMutation = (
  options?: Partial<Options<BatchGetPSetsData>>
): MutationOptions<
  BatchGetPSetsResponse2,
  BatchGetPSetsError,
  Options<BatchGetPSetsData>
> => {
  const mutationOptions: MutationOptions<
    BatchGetPSetsResponse2,
    BatchGetPSetsError,
    Options<BatchGetPSetsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await batchGetPSets({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * BatchGetPSetsByDef
 *
 * Batch get pset instances of given pset definition (lib, def) by list of links in json body. A single operation cat retrieve up to 16MB of data, but max 100 items in one request. The operation returns a partial result if the response size limit is exceeded or an internal processing failure occurs. If a partial result is returned, the operation returns a value for `unprocessed` property in the response. You can use this value to retry the operation starting with the next item to get.
 * Important. If the service returns any unprocessed items, you should retry the batch operation on those items. However, we strongly recommend that you use an exponential backoff algorithm with jitter. If you retry the batch operation immediately, the underlying read or write requests can still fail due to throttling. If you delay the batch operation using exponential backoff, the individual requests in the batch are much more likely to succeed.
 * To minimize response latency, `BatchGetPSets` retrieves items in parallel. When designing your application, keep in mind that service does not return items in any particular order. If a requested item does not exist, it is not returned in the result (no errors will be returned).
 * This API is a variation of a more generic /batch-get API. The libId and defId gave in the URL act as a default value for the definition of identity if these properties are not specified explicitly in the request body.
 *
 * @deprecated
 */
export const batchGetPSetsByDefMutation = (
  options?: Partial<Options<BatchGetPSetsByDefData>>
): MutationOptions<
  BatchGetPSetsByDefResponse2,
  BatchGetPSetsByDefError,
  Options<BatchGetPSetsByDefData>
> => {
  const mutationOptions: MutationOptions<
    BatchGetPSetsByDefResponse2,
    BatchGetPSetsByDefError,
    Options<BatchGetPSetsByDefData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await batchGetPSetsByDef({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * ChangesetPSets
 *
 * Post changeset for processing. This operation allows sending a set of property set inserts/updates/deletes in a single request for efficient processing. The changeset is processed synchronously if the number of items in changeset less then or equal to 500. For large changesets, it returns 202 status code and processes the changeset asynchronously. The maximum body size is about 4MB, but already for changesets > 500KB, it is recommended (as a more efficient method) to use the asynchronous changeset API that allows us to initiate and upload the changeset content in streaming mode.
 */
export const changesetPSetsMutation = (
  options?: Partial<Options<ChangesetPSetsData>>
): MutationOptions<
  ChangesetPSetsResponse,
  ChangesetPSetsError,
  Options<ChangesetPSetsData>
> => {
  const mutationOptions: MutationOptions<
    ChangesetPSetsResponse,
    ChangesetPSetsError,
    Options<ChangesetPSetsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await changesetPSets({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * ChangesetPSetsAsync
 *
 * Initialize a changeset and get a link for uploading changeset content for later processing.
 * This operation allows sending a set of property set inserts/updates/deletes in a single request.
 * A link is provided for uploading the actual changeset content. Use PUT with that link to upload content. No additional
 * HTTP headers to be sent other than Content-Type.
 * This async variation of the changeset API allows us to work with really large changeset (up to 5GB) uploaded in streaming mode.
 * The changeset content must be uploaded in Newline Delimited JSON format (see http://ndjson.org/, Content-Type=application/x-ndjson).
 * Example of the changeset content to be uploaded (a json formatted resource per line)
 * ```json
 * { "link": "frn:foo1", "libId": "123", "defId": "xyz", "props": { "prop1": 88, "prop2": "Darth" } }
 * { "link": "frn:foo1", "libId": "4", "defId": "www", "props": { "progressPercentage": 50, "status": "InProgress" } }
 * { "link": "frn:foo3", "libId": "123", "defId": "xyz", "props": { "prop1": 100, "prop2": "Green" } }
 * ```
 * The changeset is queued for processing and the status of the processing can be requested by the "Get changeset status" operation.
 * When processing is done, also a link to download possible processing errors is returned with the status.
 * The error handling strategy is to continue on the error and return a list of errors that happened.
 */
export const changesetPSetsAsyncMutation = (
  options?: Partial<Options<ChangesetPSetsAsyncData>>
): MutationOptions<
  ChangesetPSetsAsyncResponse,
  ChangesetPSetsAsyncError,
  Options<ChangesetPSetsAsyncData>
> => {
  const mutationOptions: MutationOptions<
    ChangesetPSetsAsyncResponse,
    ChangesetPSetsAsyncError,
    Options<ChangesetPSetsAsyncData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await changesetPSetsAsync({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChangesetStatusQueryKey = (
  options: Options<GetChangesetStatusData>
) => createQueryKey('getChangesetStatus', options);

/**
 * GetChangesetStatus
 *
 * Get changeset status.
 */
export const getChangesetStatusOptions = (
  options: Options<GetChangesetStatusData>
) =>
  queryOptions<
    GetChangesetStatusResponse,
    GetChangesetStatusError,
    GetChangesetStatusResponse,
    ReturnType<typeof getChangesetStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChangesetStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChangesetStatusQueryKey(options),
  });

export const listPsetsByLinkQueryKey = (
  options: Options<ListPsetsByLinkData>
) => createQueryKey('listPsetsByLink', options);

/**
 * Lists PSets attached to a given link.
 *
 * List pset instances attached to a given link. This API search psets across all definitions and libraries.
 */
export const listPsetsByLinkOptions = (options: Options<ListPsetsByLinkData>) =>
  queryOptions<
    ListPsetsByLinkResponse,
    ListPsetsByLinkError,
    ListPsetsByLinkResponse,
    ReturnType<typeof listPsetsByLinkQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPsetsByLink({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPsetsByLinkQueryKey(options),
  });

/**
 * DeletePSet
 *
 * Mark pset for given external entity as deleted. The resource is not deleted from the system but marked as deleted. All data is preserved. The version of the resource is incremented. Most of the other operations will refuse to work with items marked as deleted unless the 'deleted' query parameter is specified. The resource can be undeleted with PATCH operation.
 */
export const deletePSetMutation = (
  options?: Partial<Options<DeletePSetData>>
): MutationOptions<
  DeletePSetResponse,
  DeletePSetError,
  Options<DeletePSetData>
> => {
  const mutationOptions: MutationOptions<
    DeletePSetResponse,
    DeletePSetError,
    Options<DeletePSetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deletePSet({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPSetQueryKey = (options: Options<GetPSetData>) =>
  createQueryKey('getPSet', options);

/**
 * GetPSet
 *
 * Get the pset.
 */
export const getPSetOptions = (options: Options<GetPSetData>) =>
  queryOptions<
    GetPSetResponse,
    GetPSetError,
    GetPSetResponse,
    ReturnType<typeof getPSetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPSet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPSetQueryKey(options),
  });

/**
 * UpdatePSet
 *
 * Create or update pset for given external resource with upsert semantic. If pset did exist, the entity version is incremented. If the version is given in the payload or the `If-Match` header then the operation is executed with update semantic. If a negative version is given in the payload or the `If-None-Match&#58; *` header is present then the operation is executed with insert semantic. This operation will undelete the pset definition if it was marked as deleted.
 */
export const updatePSetMutation = (
  options?: Partial<Options<UpdatePSetData>>
): MutationOptions<
  UpdatePSetResponse,
  UpdatePSetError,
  Options<UpdatePSetData>
> => {
  const mutationOptions: MutationOptions<
    UpdatePSetResponse,
    UpdatePSetError,
    Options<UpdatePSetData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePSet({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listPSetVersionsQueryKey = (
  options: Options<ListPSetVersionsData>
) => createQueryKey('listPSetVersions', options);

/**
 * ListPSetVersions
 *
 * Returns the collection of versions for the given pset.
 */
export const listPSetVersionsOptions = (
  options: Options<ListPSetVersionsData>
) =>
  queryOptions<
    ListPSetVersionsResponse,
    ListPSetVersionsError,
    ListPSetVersionsResponse,
    ReturnType<typeof listPSetVersionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPSetVersions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPSetVersionsQueryKey(options),
  });

export const getPSetVersionQueryKey = (options: Options<GetPSetVersionData>) =>
  createQueryKey('getPSetVersion', options);

/**
 * GetPSetVersion
 *
 * Returns specific version for the given pset. Requested version is returned even if resource is marked as deleted.
 */
export const getPSetVersionOptions = (options: Options<GetPSetVersionData>) =>
  queryOptions<
    GetPSetVersionResponse,
    GetPSetVersionError,
    GetPSetVersionResponse,
    ReturnType<typeof getPSetVersionQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPSetVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPSetVersionQueryKey(options),
  });

export const psetsSyncQueryKey = (options: Options<PsetsSyncData>) =>
  createQueryKey('psetsSync', options);

/**
 * PsetsSync - lists PSets and returns changeToken for getting later changes fast.
 *
 * PsetsSync is similar to [ListPSetsByDef](#/PSets/ListPSetsByDef) as PsetsSync also returns a paginated list of PSets. PsetsSync is meant to be used for initial state synchronization to support other syncing methods. There are two changes compared to ListPSetsByDef:
 *
 * 1.Only non-deleted psets can be fetched.
 *
 * 2.Each page of responses also contains cursor (known as *changeToken*) of the latest information returned so that later [fetch of changes](#/PSets%20Syncing%20BETA/ListChangedPSets) can return changed pSets only.
 *
 * If the multi-page response is interrupted the changeToken in the last page received can be used for later [fetch of changes](#/PSets%20Syncing%20BETA/ListChangedPSets) without having to complete the initial fetch successfully.
 *
 * @deprecated
 */
export const psetsSyncOptions = (options: Options<PsetsSyncData>) =>
  queryOptions<
    PsetsSyncResponse,
    PsetsSyncError,
    PsetsSyncResponse,
    ReturnType<typeof psetsSyncQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await psetsSync({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: psetsSyncQueryKey(options),
  });

export const listPSetChangesByLibQueryKey = (
  options: Options<ListPSetChangesByLibData>
) => createQueryKey('listPSetChangesByLib', options);

/**
 * Fetches changes in PSets by library
 *
 * Lists the psets that have been changed in the library at or after the given 'changeToken', including deleted psets. The first 'changeToken' must be gotten from [ListPSetsByLib](#/PSets/ListPSetsByLib).
 */
export const listPSetChangesByLibOptions = (
  options: Options<ListPSetChangesByLibData>
) =>
  queryOptions<
    ListPSetChangesByLibResponse,
    ListPSetChangesByLibError,
    ListPSetChangesByLibResponse,
    ReturnType<typeof listPSetChangesByLibQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPSetChangesByLib({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPSetChangesByLibQueryKey(options),
  });

export const listPSetChangesByDefQueryKey = (
  options: Options<ListPSetChangesByDefData>
) => createQueryKey('listPSetChangesByDef', options);

/**
 * Fetches changes in PSets by definition
 *
 * Gets the psets related to specific definition that are changed at or after the given 'changeToken'. Deleted psets are included, too. The first 'changeToken' must be gotten from [ListPSetsByDef](#/PSets/ListPSetsByDef).
 */
export const listPSetChangesByDefOptions = (
  options: Options<ListPSetChangesByDefData>
) =>
  queryOptions<
    ListPSetChangesByDefResponse,
    ListPSetChangesByDefError,
    ListPSetChangesByDefResponse,
    ReturnType<typeof listPSetChangesByDefQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPSetChangesByDef({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listPSetChangesByDefQueryKey(options),
  });
